import * as React from 'react';
import { createContext, useContext, useMemo, useState } from 'react';

export interface MenuContextType {
  menuIndex: number;
  setMenuIndex: React.Dispatch<React.SetStateAction<number | undefined>>;
}

const MenuContext = createContext<MenuContextType>({} as MenuContextType);

export const useMenuDetails = () => {
  return useContext(MenuContext);
};

export const MenuProvider = ({ children }: { children: React.ReactNode }) => {
  const [menuIndex, setMenuIndex] = useState<number>();

  const values = useMemo<MenuContextType>(() => {
    return {
      menuIndex,
      setMenuIndex
    } as MenuContextType;
  }, [menuIndex, setMenuIndex]);

  return <MenuContext.Provider value={values}>{children}</MenuContext.Provider>;
};
